import type { IntegerProblem } from '@/core/cuts'

export interface CloneIntegerProblemOptions {
  includeFracData?: boolean
}

export function cloneIntegerProblem(
  problem: IntegerProblem,
  options: CloneIntegerProblemOptions = {},
): IntegerProblem {
  const cloned: IntegerProblem = {
    A: problem.A.map((row) => row.slice()),
    b: problem.b.slice(),
    c: problem.c.slice(),
    inequalities: problem.inequalities.map((ineq) => ({
      alpha: ineq.alpha.slice(),
      beta: ineq.beta,
    })),
  }

  if (options.includeFracData && problem.fracData) {
    cloned.fracData = problem.fracData
  }

  return cloned
}
